import QuestionValue from "./QuestionValue";

export default class QuestionValueTime12 extends QuestionValue{
	constructor(value) {
		super(value);
	}

	toTime() {
		let h = this._value[0] > 12 ? this._value[0] - 12 : this._value[0];
		let m = this._value[1] < 10 ? `0${this._value[1]}` : this._value[1];
		return this._value[0] >= 12 ? `${h}:${m}pm` : `${h}:${m}am`;
	}

	toString(){
		let fullString = '';

		let h = this._value[0];
		if(h !== 0){
			let hh = this._value[0] === 1 ? 'hour' : 'hours';
			fullString = `${h} ${hh} `;
		}

		let m = this._value[1];
		if(m !== 0){
			let mm = this._value[1] === 1 ? 'minute' : 'minutes';
			fullString = fullString + `${m} ${mm} `;
		}
		return fullString;
	}
}